import { ListagemItem, ModuloListagem } from "../types"

export const percentualPotenciaMinimoModulos = Number(process.env.REACT_APP_PERCENTUAL_POTENCIA_MAXIMA_INVERSORES_MINIMO_MODULOS || 13);
export const percentualPotenciaMaximoModulos = Number(process.env.REACT_APP_PERCENTUAL_POTENCIA_MAXIMA_INVERSORES_MAXIMO_MODULOS || 30);

export type ModalType = 'min-inverters' | 'min-modulos'
export const checarPotenciaTotal = (moduloSelecionado: ModuloListagem, listaInversores: ListagemItem[]): { status: boolean, type?: ModalType } => {
  const potenciaModulo = moduloSelecionado?.potencia || 0
  const numModulos = moduloSelecionado?.quantidade || 0

  const potenciaTotalInversores = listaInversores.reduce((acc,curr) => acc + Number(curr.potenciaMaximaEntradaCC || 0) * Number(curr.quantidade || 0), 0)
  
  if (numModulos === 0) return { status: false }
  if (potenciaModulo === 0) return { status: false }
  if (potenciaTotalInversores === 0) return { status: false }

  const potenciaTotalModulos = potenciaModulo * numModulos
  const percentualMinimoDecimal = percentualPotenciaMinimoModulos / 100
  const percentualMaximoDecimal = percentualPotenciaMaximoModulos / 100

  const potenciaMinimaInversor = potenciaTotalInversores * percentualMinimoDecimal
  const potenciaMaximaInversor = potenciaTotalInversores * (1 + percentualMaximoDecimal)

  const potenciaMinimaModulos = potenciaTotalModulos * 0.3

  if (potenciaTotalInversores <= potenciaMinimaModulos) {
    return { status: true, type: 'min-inverters' }
  }

  if (potenciaTotalModulos >= potenciaMinimaInversor && potenciaTotalModulos <= potenciaMaximaInversor) {
    return { status: false }
  }

  return { status: true, type: 'min-modulos' }
}